import { Chip } from '@mui/material';
import { PublishStatus } from 'common/dto-types/event-dto';

const PublishStatusCell = ({ value }: { value: number }): JSX.Element => {
    switch (value) {
        case PublishStatus.Draft:
            return <Chip color="default" label="Draft" size="small" variant="light" />;
        case PublishStatus.Published:
            return <Chip color="success" label="Published" size="small" variant="light" />;
        default:
            return <p>Unknown</p>;
    }
};

export default PublishStatusCell;
